import { EncounterType, EncounterTypeConfig } from '@hb/shared'
import { FC } from 'react'
import { EncounterTypeHeaderContentProps } from '../types'
import { AntepartumExamHeaderContent } from './Antepartum'
import { UltrasoundExamHeaderContent } from './Ultrasound'

export const EncounterTypeHeaderComponents: Partial<{
  [K in EncounterType]: FC<EncounterTypeHeaderContentProps<K>>
}> = {
  [EncounterType.ANTEPARTUM]: AntepartumExamHeaderContent,
  [EncounterType.ULTRASOUND]: UltrasoundExamHeaderContent,
}

export const ExamTypeHeaderContent = <T extends EncounterType>({
  examType,
  config,
}: {
  examType: T
  config: EncounterTypeConfig<T> | null
}) => {
  switch (examType) {
    case EncounterType.ANTEPARTUM:
      return (
        <AntepartumExamHeaderContent
          config={config as EncounterTypeConfig<EncounterType.ANTEPARTUM>}
        />
      )
    case EncounterType.ULTRASOUND:
      return (
        <UltrasoundExamHeaderContent
          config={config as EncounterTypeConfig<EncounterType.ULTRASOUND>}
        />
      )
    default:
      return null
  }
}
